import axios from 'axios';
import { UseMutationOptions, useMutation } from 'react-query';

const API_URL = import.meta.env.VITE_API_URL;

interface ChangePasswordInput {
  oldPassword: string;
  newPassword: string;
}

export const useChangePassword = (
  options?: UseMutationOptions<{ success: boolean }, unknown, ChangePasswordInput>
) => {
  return useMutation({
    ...options,
    mutationKey: ['change-password'],
    mutationFn: async (data: ChangePasswordInput) => {
      const response = await axios.post(`${API_URL}/auth/change-password`, data, {
        withCredentials: true,
      });
      return response.data;
    },
  });
};
